import * as React from 'react';
import { trackSignupClicked } from '../../utils/tracking';

interface Props {
  loginUrl: string;
  whatsappUrl: string;
}

export function FinalCTA({ loginUrl, whatsappUrl }: Props) {
  return (
    <section className="sq-cta">
      <style>{`
        .sq-cta {
          padding: 80px 24px;
          background: #1a1a1a;
          text-align: center;
        }
        .sq-cta-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .sq-cta h2 {
          font-size: 32px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 14px;
          line-height: 1.25;
        }
        .sq-cta p {
          font-size: 17px;
          color: rgba(255, 255, 255, 0.75);
          margin: 0 0 34px;
          line-height: 1.6;
        }
        .sq-cta-btns {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        @media (max-width: 768px) {
          .sq-cta { padding: 64px 20px; }
          .sq-cta h2 { font-size: 26px; }
        }
        @media (max-width: 640px) {
          .sq-cta-btns { flex-direction: column; }
        }
      `}</style>

      <div className="sq-cta-inner">
        <h2>Estés donde estés, que en su casa haya cosas frescas</h2>
        <p>Creá tu cuenta y hacé el primer pedido en unos minutos.</p>
        <div className="sq-cta-btns">
          <a
            href={loginUrl}
            className="sq-btn-primary"
            onClick={() => trackSignupClicked('seres-queridos', 'footer')}
          >
            <i className="fa fa-user-plus" /> Crear una cuenta
          </a>
          <a href={whatsappUrl} className="sq-btn-secondary" target="_blank" rel="noopener noreferrer">
            <i className="fa fa-whatsapp" /> Consultar por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
